import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore } from 'redux-persist';

import rootReducer from './rootReducer';
import API from '../services/API';

export default function configureStore(onCompletion = () => {}) {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const rootEnhancer = composeEnhancers(applyMiddleware(thunk));

  const store = createStore(rootReducer, rootEnhancer);

  const persistor = persistStore(store, null);

  return { store, persistor };
}
